function sfDate(date = new Date()) {
  const options = { timeZone: "America/Los_Angeles", hour12: false };
  return new Intl.DateTimeFormat("en-US", {
      ...options,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
  }).format(new Date(date));
}

function sfTime(date = new Date()) {
  const options = { timeZone: "America/Los_Angeles", hour12: false };
  return new Intl.DateTimeFormat("en-US", {
      ...options,
      hour: "2-digit",
      minute: "2-digit"
  }).format(new Date(date));
}

function formatDate(date = sfDate(), formatType = "YYYY-MM-DD") {
  const optionsLong = { weekday: "long", month: "long", day: "numeric", timeZone: "America/Los_Angeles" };
  if (formatType === "YYYY-MM-DD") return new Intl.DateTimeFormat("en-CA").format(new Date(date));
  if (formatType === "Long") return new Intl.DateTimeFormat("en-US", optionsLong).format(new Date(date));
  else throw new Error("Invalid format type. Use 'YYYY-MM-DD' or 'Long'.");
}

// function addDays(date, days) {
//   const result = sfDate(date);
//   result.setDate(result.getDate() + days);
//   return result;
// }

window.addDays = function(dateStr, days = 0) {
  if (!dateStr) return;
  days = parseInt(days)
  const [year, month, day] = dateStr.split('-').map(Number);
  const date = new Date(year, month - 1, day, 0, 0, 0);
  date.setDate(date.getDate() + days);
  return formatDate(sfDate(date), "YYYY-MM-DD");
}

function subtractDays(dateStr, days = 0) {
  if (!dateStr) return;
  days = parseInt(days)
  const [year, month, day] = dateStr.split('-').map(Number);
  const date = new Date(year, month - 1, day, 0, 0, 0);
  date.setDate(date.getDate() - days);
  return formatDate(sfDate(date), "YYYY-MM-DD");
}

function dateIsToday(dateStr) {
  return dateStr === formatDate(sfDate());
}

function dateIsPast(dateStr) {
  return new Date(dateStr) < new Date(formatDate(sfDate()));
}


window.formatToLongDate = function(dateStr) {
  if (!dateStr) return;
  const [year, month, day] = dateStr.split('-').map(Number);
  const date = new Date(year, month - 1, day, 0, 0, 0);
  const options = { weekday: "long", month: "long", day: "numeric", timeZone: "America/Los_Angeles" };
  return new Intl.DateTimeFormat("en-US", options).format(date);
}